/**
 * Human byte sizes — the ONE formatter every storage figure in the product
 * renders through (the Energy Hub's footprint line, the Gray Stack breakdown,
 * the Conversation Data card's Memory Storage Cost).
 *
 * BINARY units (1024), because that is what the storage rate is quoted against:
 * `energy_service.BYTES_PER_GB` is 1024³, so a "GB" shown here has to be the
 * same GB the points figure beside it was priced from. Two different gigabytes
 * on one line is how a statement stops being reconcilable.
 *
 * Returns `null` — never "0 B" — for a missing or nonsensical value, so callers
 * can render an em-dash rather than assert something they were not told.
 */
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatBytes(bytes) {
    // Guarded BEFORE Number(), which coerces null and '' to 0 — that would turn
    // "nobody told us" into the confident claim "it is empty".
    if (bytes == null || bytes === '') return null;
    const n = Number(bytes);
    if (!Number.isFinite(n) || n < 0) return null;
    let value = n;
    let unit = 0;
    while (value >= 1024 && unit < UNITS.length - 1) {
        value /= 1024;
        unit += 1;
    }
    return `${unit === 0 ? value : value.toFixed(1)} ${UNITS[unit]}`;
}

export default formatBytes;
